import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import {
  checkLoginStatus,
  getAgentId,
  getAgentName,
  getRoCode
} from "../../store/selectors/loginSelector";
import { getCompanyName } from "../../store/selectors/appConfig";
import { logout } from "../../store/actions/loginForm";
import { getAccountType } from "../../store/selectors/appConfig";
import { getIsIslamicBanking } from "../../store/selectors/appConfig";

import { accountNames, applicationOverviewRoutes } from "../../constants";
import routes from "../../routes";
import { accountTypes } from "../../containers/AccountsComparison/constants";
import { StyledHeaderTitle } from "./styled";

const HeaderTitleComponent = ({
  islamicBanking,
  accountType,
  companyName,
  isAgent,
  withoutMarginBottom,
  logout,
  agentName,
  roCode,
  agentId
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  let selectedAccountTypeName = "";
  switch (accountType) {
    case accountNames.elite:
      selectedAccountTypeName = accountTypes.elite.name;
      break;
    case accountNames.currentAccount:
      selectedAccountTypeName = accountTypes.currentAccount.name;
      break;
    case accountNames.starter:
    default:
      selectedAccountTypeName = accountTypes.starter.name;
      break;
  }

  const agentLogout = useCallback(() => {
    logout({ agentId });
    navigate(routes.login);
  }, [logout, navigate]);

  const hideHeaderTile = pathname.endsWith(routes.verifyMobileOtp);

  return (
    <StyledHeaderTitle
      className={hideHeaderTile ? "hideHeaderTile" : ""}
      withoutMarginBottom={withoutMarginBottom}
    >
      <div className={"headerTitleIn"}>
        <span>
          {/* //ro-assist header missing issue fix */}
          {isAgent && agentName && agentName.trim() !== "" && (
            <>
              {/* ro-assistant-scr-0.7 */}
              <div>
                {agentName} - {roCode}
              </div>
              <div className={"logout"} onClick={() => agentLogout()}>
                Logout
              </div>
            </>
          )}
          {/* //ro-assist header missing issue fix */}
          {![routes.searchProspect.split("/")[1]].includes(pathname.split("/")[1]) && (
            <>
              {selectedAccountTypeName} {islamicBanking && "RAKislamic"} Application{" "}
            </>
          )}
          {!applicationOverviewRoutes.includes(pathname) && companyName && (
            <>
              for <span>{companyName}</span>
            </>
          )}
        </span>
      </div>
    </StyledHeaderTitle>
  );
};

/**
 * PropTypes for HeaderTitleComponent
 */
HeaderTitleComponent.propTypes = {
  /** Flag indicating if Islamic banking is enabled */
  islamicBanking: PropTypes.bool,
  /** Type of account being applied for */
  accountType: PropTypes.string,
  /** Name of the company for the application */
  companyName: PropTypes.string,
  /** Flag indicating if user is an agent */
  isAgent: PropTypes.bool,
  /** Flag to remove margin bottom styling */
  withoutMarginBottom: PropTypes.bool,
  /** Function to handle logout */
  logout: PropTypes.func,
  /** Name of the agent (if applicable) */
  agentName: PropTypes.string,
  /** RO code for the agent */
  roCode: PropTypes.string,
  /** Agent ID for logout functionality */
  agentId: PropTypes.string
};

const mapStateToProps = state => ({
  agentName: getAgentName(state),
  agentId: getAgentId(state),
  isAgent: checkLoginStatus(state),
  islamicBanking: getIsIslamicBanking(state),
  accountType: getAccountType(state),
  companyName: getCompanyName(state),
  roCode: getRoCode(state)
});

const mapDispatchToProps = {
  logout
};

export const HeaderTitle = connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderTitleComponent);
